export default {
  mainWrapper:
    'md:h-full md:w-12/12 lg:w-innerContainer mx-auto px-35 md:px-0 flex flex-row flex-wrap',
  leftWrapper: 'w-full md:w-3/12 left-wrapper mr-10p',
  rightWrapper:
    'w-full md:w-65p pb-80 lg:p-0 sm:pt-40 md:pt-0 md:pt-0 right-wrapper md:px-20',
  howtoUse: 'how-to-use-heading discover-button',
  slideTextSection: 'product-after-before relative md:pb-70 pb-70',
  slideImageSection: 'overflow-hidden relative slide-image-animate',
  slideAfterImg: 'border-t border-solid border-white',
};
